jQuery(function($){
	const parentSelector = '.sc-email-list-manager--detail-lists'

	//Heading
	$(parentSelector).on('click', '.detail-list--heading > .heading-buttons .heading-button.edit-button', function(){
		const parentDiv = $(this).closest('.detail-list');
		parentDiv.addClass('editing');
	});

	$(parentSelector).on('click', '.detail-list--heading > .heading-buttons .heading-button.close-button', function(){
		const parentDiv = $(this).closest('.detail-list');
		parentDiv.removeClass('editing');
	});


	//Subheading
	$(parentSelector).on('click', '.detail-list--subheading > .heading-buttons .heading-button.edit-button', function(){
		const parentDiv = $(this).closest('.detail-list--subheading-wrapper');
		const otherWrappers = $('.detail-list--subheading-wrapper');
		otherWrappers.removeClass('editing');
		parentDiv.addClass('editing');

		setTimeout(function(){
			const listPosition = parentDiv.closest('.detail-list').position();
			console.log(listPosition);
			window.scroll(0, Math.round(listPosition.top));
		}, 300);
	});

	$(parentSelector).on('click', '.detail-list--subheading > .heading-buttons .heading-button.close-button', function(){
		const parentDiv = $(this).closest('.detail-list--subheading-wrapper');
		parentDiv.removeClass('editing');
	});



	$(parentSelector).on('change', '.detail-list--details-edit input[type="radio"]', function(){
		const parentDiv = $(this).closest('.detail-list');
		$(this).closest('.detail-list--details-edit')[0].classList = 'detail-list--details-edit type--' + $(this).val();

		parentDiv.attr('type', $(this).val());
	});

	$(parentSelector).on('click', '.remove-address', function(){
		const addressDiv = $(this).closest('.address-field');
		const parentDiv = $(this).closest('.detail-list--details-edit');

		if(parentDiv.find('.address-field').length <= 1) {
			window.alert('You are not allowed to remove the final email field');
		} else {
			addressDiv.remove();
		}
	});

	$(parentSelector).on('click', '.detail-list--details-edit .add-address', function(){
		const newAddressMarkup = '<div class="address-field"><input type="email" value=""><div class="remove-address"><span class="fas fa-close"></span></div></div>';
		$(this).closest('.detail-list--list-action-buttons').before(newAddressMarkup);
	});

});